import React, { useState, useEffect } from 'react';
import { Auth } from '../MainPage';
import Dialogs from './Dialogs';
import Chat from './Chat/Chat';
import UserInfo from './UserInfo';
import { client } from '../../shared';
import { url } from '../../shared';
import { taxStatusOptions, userStatusOptions } from '../../shared/constants';
import { userStatusInnerText } from '../../shared/utils';
import { connect } from '../../shared/ws';
import './active-dialogs.scss';
import useDialogLists from './useDialogLists';

const DialogsHeader = (props) => {
  const { column1, column2 } = props;
  return (
    <div className="active-dialogs__header">
      <div>{column1.name}</div>
      {column2 && <div>{column2.name}</div>}
    </div>
  );
};

const ActiveDialogs = () => {
  const [count, forceUpdate] = useState<number>(0);
  const [chatId, setChatId] = useState<number | null>(null);
  const myContent: Array<object> = [];
  const activeContent: Array<object> = [];
  const processContent: Array<object> = [];
  const [incomingMessages, setIncomingMessages] = useState<any>(null);
  const [chatContent, setChatContent] = useState<Record<string, any> | null>(
    null
  );
  const {
    chats,
    loading: dialogLoading,
    loadMore,
    refresh,
    activeError,
    processError,
  } = useDialogLists(count, incomingMessages);

  useEffect(() => {
    return connect(setIncomingMessages, Auth.Login, Auth.Password);
  }, []);

  const sortContentByType = () => {
    if (chats) {
      for (let chat of chats as any) {
        switch (chat && chat.chatStatus) {
          case 'ACTIVE':
            activeContent.push(chat);
            break;
          case 'PROCESS':
            chat.admin && chat.admin.email === Auth.Login
              ? myContent.push(chat)
              : processContent.push(chat);
            break;
        }
      }
    }
  };
  sortContentByType();

  const onChatClick = (chat) => {
    setChatId(chat.id);
    client
      .post(`${url.chatsMessages2}/${chat.id}`, {
        offset: 0,
        size: 10,
      })
      .then(({ data }) => {
        setChatContent({ ...chat, messages: data.payload });
      });
  };

  return (
    <div className="page table-page">
      <h1 className="page__header">Активные диалоги</h1>
      <div className="active-dialogs">
        <div className="active-dialogs__category">
          <DialogsHeader
            column1={{ name: 'Диалоги:' }}
            column2={{ name: 'Сообщения:' }}
          />
          <Dialogs
            header={'Новые:'}
            error={activeError}
            retry={refresh}
            content={activeContent}
            setChatId={(chat) => onChatClick(chat)}
            count={count}
            update={forceUpdate}
            scrollTop={loadMore}
            loading={dialogLoading}
          />
          <Dialogs
            header={'Мои диалоги:'}
            error={processError}
            retry={refresh}
            content={myContent}
            setChatId={(chat) => onChatClick(chat)}
            count={count}
            update={forceUpdate}
            scrollTop={loadMore}
            loading={dialogLoading}
          />
          <Dialogs
            header={'Остальные:'}
            error={processError}
            retry={refresh}
            content={processContent}
            setChatId={(chat) => onChatClick(chat)}
            count={count}
            update={forceUpdate}
            scrollTop={loadMore}
            loading={dialogLoading}
          />
        </div>

        <div className="active-dialogs__chat">
          <Chat
            content={chatContent}
            setChatId={setChatId}
            iAm={Auth.Login}
            chatId={chatId}
            count={count}
            update={forceUpdate}
          />
        </div>

        <div className="active-dialogs__user-info">
          <DialogsHeader column1={{ name: 'Пользователь' }} />
          <UserInfo
            placeholder={'ФИО'}
            value={
              chatContent?.user
                ? chatContent?.user.legal
                  ? `${chatContent.user.responsible}`
                  : `${chatContent?.user.surname} ${chatContent?.user.username} ${chatContent?.user.patronymic}`
                : ''
            }
          />
          <UserInfo
            placeholder={'Статус'}
            value={
              chatContent?.user &&
              userStatusInnerText(chatContent.user.status, userStatusOptions)
            }
          />
          <UserInfo
            placeholder={'Статус ФНС'}
            value={
              chatContent?.user &&
              userStatusInnerText(chatContent.user.taxStatus, taxStatusOptions)
            }
          />
          <UserInfo
            placeholder={'Телефон'}
            value={chatContent?.user && chatContent.user.mobile}
          />
        </div>
      </div>
    </div>
  );
};

export default ActiveDialogs;
